var exports = {
  "k": "x234b8571--31f2d0--container",
};

module.exports = exports;
